var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrap"},[_c('div',{staticClass:"login-form"},[_vm._m(0),_c('resetform',{staticClass:"resetform"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-form"},[_c('h2',[_vm._v("重置密码")])])
}]

export { render, staticRenderFns }